var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteremoved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Total_systems_icon",
    x: 10.5,
    y: 12.5,
    width: 31.213,
    height: 28.19,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Site_removed",
    "data-name": "Site removed",
    transform: "translate(-1147 -915)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38841",
    "data-name": "Path 38841",
    d: "M26,0A26,26,0,1,1,0,26,26,26,0,0,1,26,0",
    transform: "translate(1147 915)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1147, 915)",
    filter: "url(#Total_systems_icon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Total_systems_icon-2",
    "data-name": "Total systems icon",
    d: "M-172.63,371.871v25.1h15.192v-25.1Zm6.314,18.646h-3.391v-3.391h3.391Zm0-5.841h-3.391v-3.391h3.391Zm0-5.841h-3.391v-3.391h3.391Zm5.864,11.682h-3.391v-3.391h3.391Zm0-5.841h-3.391v-3.391h3.391Zm0-5.841h-3.391v-3.391h3.391Zm16.035,4.861v13.365h-3.541v-7.049h-5.287v7.049h-3.541V383.7Zm0-2.461h-12.369V383.1h12.369Z",
    transform: "translate(184.63 -358.87)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteremoved);
export default __webpack_public_path__ + "static/media/Site removed.faf74d003404a8b89b28178f8062e7ab.svg";
export { ForwardRef as ReactComponent };